import { SortProps } from "routers/types";
import React from "react";

//  ######  CustomLink  ######## //
export interface CustomLink {
  label: string | React.ReactNode;
  href?: string;
  targetBlank?: boolean;
}

//  ##########  PostDataType ######## //
export interface TaxonomyType {
  id: string | number;
  name: string;
  href: string;
  count?: number;
  thumbnail?: string;
  desc?: string;
  color?: TwMainColor | string;
  taxonomy: "category" | "tag";
  listingType?: "stay" | "experiences" | "car";
}

export interface AuthorType {
  id: string | number;
  firstName: string;
  lastName: string;
  displayName: string;
  avatar: string;
  bgImage?: string;
  email?: string;
  count: number;
  desc: string;
  jobName: string;
  href: string;
  starRating?: number;
}

export interface PostDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  categories: TaxonomyType[];
  title: string;
  featuredImage: string;
  desc?: string;
  commentCount: number;
  viewdCount: number;
  readingTime: number;
  postType?: "standard" | "video" | "gallery" | "audio";
}

export type TwMainColor =
  | "pink"
  | "green"
  | "yellow"
  | "red"
  | "indigo"
  | "blue"
  | "purple"
  | "gray";

//
export interface StayDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  title: string;
  featuredImage: string;
  commentCount: number;
  viewCount: number;
  address: string;
  reviewStart: number;
  reviewCount: number;
  like: boolean;
  galleryImgs: string[];
  price: string;
  listingCategory: TaxonomyType;
  maxGuests: number;
  bedrooms: number;
  bathrooms: number;
  saleOff?: string | null;
  isAds: boolean | null;
  map: {
    lat: number;
    lng: number;
  };
}

//
export interface ExperiencesDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  title: string;
  featuredImage: string;
  commentCount: number;
  viewCount: number;
  address: string;
  reviewStart: number;
  reviewCount: number;
  like: boolean;
  galleryImgs: string[];
  price: string;
  listingCategory: TaxonomyType;
  maxGuests: number;
  saleOff?: string | null;
  isAds: boolean | null;
  map: {
    lat: number;
    lng: number;
  };
}

export interface CarDataType {
  id: string | number;
  author: AuthorType;
  date: string;
  href: string;
  title: string;
  featuredImage: string;
  commentCount: number;
  viewCount: number;
  address: string;
  reviewStart: number;
  reviewCount: number;
  like: boolean;
  galleryImgs: string[];
  price: string;
  listingCategory: TaxonomyType;
  seats: number;
  gearshift: string;
  saleOff?: string | null;
  isAds: boolean | null;
  map: {
    lat: number;
    lng: number;
  };
}


export interface Cars {
  meta: {
    carId: string
    stockId: string
    advertiserId: string
  }
  media: { images: [{ href: string }], video: { href: string } };
  make: string;
  model: string;
  yearOfManufacture: string;
  fuelType: string;
  color: string | null;
  mileage: string | null;
  transmissionType: string;
  priceGBP: string;
  body: string | null;
  doors: string | null;
  seats: string | null;
  plate: string | null;
  monthlyPayment: number | null;
  lastUpdated: string;
  dateUploaded: string;
  registration: string;
  firstRegistrationDate: string | null;
  ownershipCondition: string | null;
  description: string | null;
  attentionGrabber: string | null;
  technicalDetails: CarTechinicalDetails
  features?: []
  derivative: string | null;
}
export interface CarTechinicalDetails {
  cylinders: number | null;
  valves: number | null;
  engineTorqueNM: number | null;
  co2EmissionGPKM: number | null;
  topSpeedMPH: number | null;
  zeroToSixtyMPHSeconds: number | null;
  zeroToOneHundredKMPHSeconds: number | null;
  engineCapacityCC: number | null;
  enginePowerBHP: number | null;
}
type LabelType = {
  [key: string]: {
    label: string;
    icon: string;
    suffix?: string;
    isNumber?: boolean;
  }
};


export const technicalDetailLabels: LabelType = {
  "co2EmissionGPKM": {
    label: "CO2 Emission",
    icon: "fas fa-car",
    suffix: ""
  },
  // "cylinders": {
  //   label: "Cylinders",
  //   icon: "far fa-pipe-section",
  //   suffix: ""
  // },
  "engineCapacityCC": {
    label: "Engine Capacity",
    icon: "fal fa-engine",
    suffix: ""
  },
  "enginePowerBHP": {
    label: "Engine Power",
    icon: "fas fa-gauge-circle-bolt",
    suffix: "bhp"
  },
  "engineTorqueNM": {
    label: "Engine Torque",
    icon: "fal fa-wrench",
    suffix: "lbs/ft"
  },
  "topSpeedMPH": {
    label: "Top Speed",
    icon: "far fa-circle-bolt",
    suffix: "mph"
  },
  "zeroToSixtyMPHSeconds": {
    label: "0 to 60 mph",
    icon: "far fa-gauge-max",
    suffix: "seconds"
  }
};

export const vechicleDetailsLabels: LabelType = {
  // "body": {
  //   label: "Body",
  //   icon: "fal fa-car-wrench",
  //   suffix: ""
  // },
  "color": {
    label: "Colour",
    icon: "fal fa-spray-can",
    suffix: ""
  },
  // "doors": {
  //   label: "Doors",
  //   icon: "fal fa-door-open",
  //   suffix: ""
  // },
  "fuelType": {
    label: "Fuel Type",
    icon: "fal fa-gas-pump",
    suffix: ""
  },
  "mileage": {
    label: "Mileage",
    icon: "fal fa-tachometer-alt-fastest",
    suffix: "miles",
    isNumber: true
  },
  "transmissionType": {
    label: "Transmission",
    icon: "fal fa-cog",
    suffix: ""
  },
  // "seats": {
  //   label: "Seats",
  //   icon: "fal fa-person-seat",
  //   suffix: ""
  // },
  "serviceHistory": {
    label: "Service History",
    icon: "fal fa-oil-can-drip",
    suffix: ""
  },
}


export interface SearchFormProps {
  onInputDone?: (value: string | number[] | any, key: keyof SortProps) => void;
  placeHolder?: string;
  desc?: string;
  className?: string;
  defaultValue?: string | number[] | any;
  autoFocus?: boolean;
  data?: Facets[];
}

export interface Facets {
  value: string;
  count?: number;
}

export interface MobileSearchFormProps {
  onClick?: () => void;
  onChange?: (value: string | number[] | any) => void;
  className?: string;
  defaultValue?: string[] | number[] | any;
  headingText?: string;
  data?: Facets[];
}

export interface FinanceRequest {
  AnnualDistance?: number | string;
  CashDeposit?: number | string;
  CashPrice?: number | string;
  Identity?: string;
  IdentityType?: string;
  RegistrationDate?: string;
  Term?: number | string;
  Condition?: string;
  CurrentOdometerReading?: number | string;
}

export interface FinanceResponse {
  aer: number;
  apr: number;
  baloon: number;
  advance: number;
  intertestCharge: number;
  interestRate: number;
  term: number;
  totalPayable: number;
  totalDeposit: number;
  regularPayment: number;
  optionToPurchaseFee: number;
  quoteUID: string;
  finalPayment: number;
  totalCashPrice: number;
  numberOfRegularPayments: number;
  firstPayment: number;
}

export interface EnquiryTicket {
  email: string,
  name: string,
  message: string,
  vehicleDetails?: string,
  vehicleId?: string,
  contactPhone?: string
  url?: string
}

export interface SaleTicket {
  email: string,
  name: string,
  contactPhone?: string
  message: string;
  registration: string;
  makeAndModel: string;
  currentMileage: string;
}    